// Action Types
export const AUTH_ACTIONS = {
  SET_ACTIVE_TAB: "SET_ACTIVE_TAB",
};

// Initial State "contacts" or "connections"
const initialState = {
    activeTab : "contacts"
};

// Auth Reducer
export const ContactAndConnectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_ACTIONS.SET_ACTIVE_TAB:
      // chnage tab
      return {
        ...state,
        activeTab: action.payload,
      };

    default:
      return state;
  }
};

// Action Creators
export const setActiveTabStore = (tab) => ({
  type: AUTH_ACTIONS.SET_ACTIVE_TAB,
  payload: tab
});

export default ContactAndConnectionReducer;
